var React = require('react');
var ReactDOM = require('react-dom');
var Tooltip = require('patternity/lib/tooltip');

var BadgePopover = function() {
  function addPopovers(containerSelector, wrapperStyles = {}) {
    containerSelector = containerSelector || "body";
    var badges = $(containerSelector).find("[data-badge-container]").not("[data-badge-has-been-processed]");

    for(var i = 0; i < badges.length; i ++) {
      addPopover(badges[i], wrapperStyles);
    }
  }

  function addPopover(badgeElement, wrapperStyles = {}) {
    var badge = buildBadgeObject(badgeElement);
    buildPopover(badge, badgeElement, wrapperStyles);
  }

  function buildBadgeObject(badgeElement) {
    var $badge = $(badgeElement);
    return {
      id: $badge.data('badge-id'),
      image: $badge.data('badge-image'),
      name: $badge.data('badge-name'),
      description: $badge.data('badge-description')
    };
  }

  function buildPopover(badge, badgeElement, wrapperStyles) {
    var badgeImage = React.DOM.img({
      src: badge.image,
      alt: badge.name,
      key: 'badge-image-' + badge.id
    });

    var tooltipContent = React.DOM.div({
        style: wrapperStyles,
        key: 'badge-tooltip-' + badge.id
      },
      React.DOM.h3({
        style:{
          margin: '0px',
          padding: '5px 10px',
          textAlign: 'left',
          fontWeight: 'bold',
          color: '#fff'
        },
        key: 'badge-heading-' + badge.id
      }, badge.name),
      React.DOM.p({
        style:{
          padding: '0px 10px 10px',
          textAlign: 'left',
          color: '#fff',
          whiteSpace: 'pre-line'
        },
        key: 'badge-description-' + badge.id
      }, badge.description)
    );

    ReactDOM.render(
      React.createElement(Tooltip, {
        element: badgeImage,
        isClickable: false,
        children: [tooltipContent],
        style: {
          content: {
            minWidth: '200px',
            padding: '0px',
            fontSize: '13px'
          }
        },
        key: 'badge-' + badge.id
      }),
      $(badgeElement).get(0)
    );

    addProcessedAttribute(badgeElement);
  }

  function addProcessedAttribute(badgeElement) {
    $(badgeElement).data('data-badge-has-been-processed', null);
  }

  return {
    addPopover : addPopover,
    addPopovers : addPopovers
  };
};

module.exports = BadgePopover();



// WEBPACK FOOTER //
// ./src/components/badge_popover.js